(function($) {
    const azElements = document.querySelectorAll('.az');
    const letterLinks = document.querySelectorAll('.az-wrapper__letters a');
    const letterBoxes = document.querySelectorAll('.az-wrapper__letter-categories');

    letterLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
            const letter = link.dataset.letter;

            letterBoxes.forEach(box => {
                box.classList.toggle('active', box.dataset.letter === letter);
            });
        });
    });

    azElements.forEach(az => {
        const wrapper = az.querySelector('.az-wrapper');
        let timeout;

        az.addEventListener('mouseenter', () => {
            clearTimeout(timeout);
            wrapper.style.display = 'block';
            wrapper.style.opacity = '1';
        });

        az.addEventListener('mouseleave', () => {
            timeout = setTimeout(() => {
                wrapper.style.opacity = '0';
                setTimeout(() => {
                    wrapper.style.display = 'none';
                }, 300);
            }, 1000);
        });
    });


})(jQuery);

$(document).ready(function () {
    searchpromp = {

        st: null,
        request: null,

        setTimeout: function (func) {
            searchpromp.st = setTimeout(func, 500);
        },

        removeTimeout: function () {
            clearTimeout(searchpromp.st);
        },

        init: function () {
            //for beacouse theres 2 same inputs:w
            $.each($('.search-input'), function (index, input) {
                $(input).keyup(function (event) {
                    clearTimeout(searchpromp.st);

                    if (event.which === 27) {
                        event.currentTarget.value = '';
                        $('.search-promp').slideUp('fast');
                    } else {

                        searchpromp.st = setTimeout(function () {
                            if (this.request !== null && this.request !== undefined)
                                this.request.abort();

                            if ($(input).val().length > 1) {
                                searchpromp.startSearch($(input).val());
                            } else {
                                $('.search-promp').slideUp('fast');
                            }
                        }, 200);

                    }
                });
            }).focus(function () {
                $.each($('.search-input'), function (index, input) {
                    if ($(input).val().length > 1) {
                        searchpromp.startSearch($(input).val());
                    } else {
                        $('.search-promp').slideUp('fast');
                    }
                });
            }).focusout(function (e) {
                setTimeout(function () {
                    $('.search-promp').slideUp('fast');
                }, 150)
            });

            $(document).on('keypress', '.search-input', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    $(e.target).trigger('focusout').off();
                    var val = $(e.target).val();

                    window.location.href = location.protocol + '//' + location.hostname + '/szukaj/' + val;
                    blockUI('Trwa wyszukiwanie');
                }
            });

            $('.submit-search').on('click', function () {
                var val = $(this).parent('form').find('.search-input').val();

                window.location.href = location.protocol + '//' + location.hostname + '/szukaj/' + val;
                blockUI('Trwa wyszukiwanie');
            })

            $('body').on('click', '.lastSearch', function () {
                blockUI('Trwa wyszukiwanie');
            })
        },

        startSearch: function (s) {
            this.request = $.ajax({
                url: window.elastic,
                type: 'POST',
                dataType: "json",
                data: {'search_word': s.trim()},
                success: function (response) {
                    if (response.error) {
                        return;
                    }

                    if (isMobile()) {
                        var categoryMax = response.categories.length < 5 ? response.categories.length : 5;
                        var brandsMax = response.brands.length < 5 ? response.brands.length : 5;
                    } else {
                        var categoryMax = response.categories.length;
                        var brandsMax = response.brands.length;
                    }

                    var products_html = '<div><p>Produkty</p>';
                    if (response.products.length > 0) {
                        products_html += '<ul>';
                        console.log(response.products);
                        for (var i = 0; i < response.products.length; i++) {
                            products_html += '<li><a class="' + (response.products[i].last == true ? "lastSearch" : "") + (response.products[i].highlight ? "check-find" : "") +'" href="' + (response.products[i].url_href) + '">' + (response.products[i].show_title) + '</a></li>';
                        }
                        products_html += '</ul></div>';

                    } else {
                        products_html += '<p class="empty-block">Brak</p></div>';
                    }


                    var category_html = '<div><p>Kategorie</p>';
                    if (response.categories.length > 0) {

                        category_html += '<ul>';
                        for (var i = 0; i < categoryMax; i++) {
                            var type = response.categories[i].source;
                            category_html += '<li data-type="'+type+'"><a href="' + (response.categories[i].url_href) + '">' + (response.categories[i].breadcrumbs) + '</a><span class="search-count">' + (response.categories[i].amount) + '</span></li>';
                        }
                        category_html += '</ul></div>';

                    } else {
                        category_html += '<p class="empty-block">Brak</p></div>';
                    }

                    var brands_html = '<div><p>Marki</p>';
                    if (response.brands.length > 0) {
                        brands_html += '<ul>';

                        for (var i = 0; i < brandsMax; i++) {
                            brands_html += '<li><a href="/szukaj/' + s.trim() + '?brand=' + (response.brands[i].name) + '">' + (response.brands[i].breadcrumbs) + '</a> <span class="search-count">' + (response.brands[i].amount) + '</span></li>';
                        }

                        brands_html += '</ul></div>';

                    } else {
                        brands_html += '<p class="empty-block">Brak</p></div>';
                    }

                    var html = products_html;
                    html += category_html;
                    html += brands_html;

                    $('.search-promp').html(html);

                    $('.search-promp').slideDown({
                        duration: 'fast',
                        start: function () {
                            $(this).css({
                                display: isMobile() ? 'block' : 'flex'
                            })
                        }
                    });

                },
                error: function (response) {
                    console.log(response);
                }
            });
        }

    };

    $(document).ready(function () {
        searchpromp.init();
    });
});